import { render, staticRenderFns } from "./mallHome.vue?vue&type=template&id=cfff4af8&scoped=true"
import script from "./mallHome.vue?vue&type=script&lang=js"
export * from "./mallHome.vue?vue&type=script&lang=js"
import style0 from "./mallHome.vue?vue&type=style&index=0&id=cfff4af8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfff4af8",
  null
  
)

export default component.exports